import $ from "jquery";

$(document).on("turbolinks:load", () => {
  $("[data-role='validate-forest-id-format']").on("keyup", e => {
    let valid = /^[0-9]{1,3}-[0-9]{1,3}-[0-9]{1,3}-[0-9]{1,3}$/.test(e.target.value);
    if (e.target.dataset.nullallowed === "true" && e.target.value === "") {
      valid = true;
    }
    const $errorContainer = $("#forest-identifier-error");
    if (valid || e.target.value === "") {
      $(e.target)
        .closest(".input")
        .removeClass("input--has-error");
      $(e.target).removeAttr("aria-describedby");
      $errorContainer.hide();
    } else {
      $(e.target)
        .closest(".input")
        .addClass("input--has-error");
      $(e.target).attr("aria-describedby", "forest-identifier-error");
      $errorContainer.show();
    }

    $(e.target)
      .closest("form")
      .find("input:submit[data-role='other-identifier-form-submit']")
      .prop("disabled", !valid);

    if (valid && e.keyCode === 13) {
      $(e.target)
        .closest("form")
        .submit();
    }
  });

  $(
    "[data-role='other-identifier-form-submit'], [data-role='toggle-loading-indicator']"
  ).on("click", e => {
    e.preventDefault();
    $(e.target)
      .closest("form")
      .find(".code-search__error")
      .hide();
    $(e.target)
      .closest("form")
      .find("[data-role='loading-spinner-wrapper']")
      .show();
    const $notificationText = $(e.target).closest("form").find("#notification_text");
    $notificationText.text(""); // Clear the text briefly for screen readers to recognise the new text
    setTimeout(() => {
      $notificationText.text("Odota hetki. Haetaan ja tarkistetaan kiinteistön tietoja.");
    }, 0);
    $(e.target)
      .closest("form")
      .find(".input-error")
      .hide();
    $(e.target)
      .closest("form")
      .submit();
  });

  $("[data-role='continue-to-payment']").on("click", e => {
    e.preventDefault();
    $(e.target)
      .closest("form")
      .find("#forest_valuation_continue_to_payment")
      .val(true);
    $(".edit_forest_valuation").submit();
  });

  const $form = $(".edit_forest_valuation"); // Select the form

  // Handle backend validation errors on page load
  $form.find(".input--has-error").each((_, element) => {
    const $wrapper = $(element); // The wrapper with the error class
    const $field = $wrapper.find("input, textarea, select"); // The associated input field
    const $error = $wrapper.find(".input-error"); // The error message element

    if ($error.length && $field.length) {
      const errorId = `${$field.attr("id")}-error`; // Generate a unique ID for the error message
      $error.attr("id", errorId); // Ensure the error message has an ID
      $field.attr("aria-describedby", errorId); // Associate the error message with the field
    }
  });

  // Focus on the first field with an error
  const $firstErrorField = $form.find(".input--has-error").first().find("input, textarea, select");
  if ($firstErrorField.length) {
    $firstErrorField.focus();
  }

  // Handle input event to remove backend validation errors dynamically
  $form.find("input, textarea, select").on("input", (e) => {
    const $field = $(e.target); // The field receiving input
    const $wrapper = $field.closest(".input"); // Find the SimpleForm wrapper

    // Remove the error class and error message dynamically
    $wrapper.removeClass("input--has-error");
    $wrapper.find(".input-error").remove();
    $field.removeAttr("aria-describedby");
    $field.removeAttr("aria-invalid");
  });
});
